// extracted by mini-css-extract-plugin
export var alert = "Alert-module--alert--100bf";
export var alertIcon = "Alert-module--alertIcon--b4ace";
export var danger = "Alert-module--danger--616db";
export var heading = "Alert-module--heading--710c1";
export var info = "Alert-module--info--b7e3e";
export var none = "Alert-module--none--af00f";
export var success = "Alert-module--success--f0c92";
export var warning = "Alert-module--warning--f131b";